module.exports = __webpack_public_path__ + "img/pending-actions-black-24-dp-1.859e2028.svg";